module.exports = __webpack_public_path__ + "e97215f87e57b587e502e9ad20af756c.svg";